import { observer } from 'mobx-react-lite';

import { Accordion } from 'us-react-components/dist/Accordion/Accordion';
import {
  namespaces,
  useSharedTranslation,
} from 'us-react-components/dist/hooks/useSharedTranslation';
import { useDependencies } from '../../../dependencies';
import { VoucherItem } from './VoucherItem';

export const InactiveCredits = observer((): JSX.Element | null => {
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { stores } = useDependencies();
  const { inactiveCredits } = stores.credits;

  if (!inactiveCredits || !inactiveCredits?.data?.data?.length) {
    return null;
  }

  return (
    <div>
      <Accordion headerText={t('pages.credits.inactiveCreditsHeader')}>
        <VoucherItem userVouchers={inactiveCredits} active={false} />
      </Accordion>
    </div>
  );
});
